function removeDiacritics(str) {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // removes combining marks
        .toLowerCase()
        .trim();
}

export {
    removeDiacritics
}